import { TalentLocale } from '@models/locales';

// When adding a new locale to the project, don't forget to update the datesLocales list in the DatesService
export const talentLocales: TalentLocale[] = ['en', 'fr'];

export const DEFAULT_MODAL_WIDTH = '600px';
